import React from 'react';
import {Link} from 'react-router-dom';
import NavBarItem from './NavBarItem';
import NavBarDropDownItem from "./NavBarDropDownItem";

function NavBar() {
    const anonym = "ROLE_ANONYMOUS";
    const user = "ROLE_USER";
    const admin = "ROLE_ADMINISTRATOR";
    const bgStyle = {
        "z-index": "15"
    };

    return (
        <nav className="navbar navbar-expand-lg bg-white">
            <div className="container" style={bgStyle}>
                <div className="navbar-translate">
                <Link className="navbar-brand" to="/">AngryNerds TRAVEL</Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false"
                        aria-label="Toggle navigation">
                    <span className="sr-only">Toggle navigation</span>
                    <span className="navbar-toggler-icon"></span><span className="navbar-toggler-icon"></span>
                    <span className="navbar-toggler-icon"></span>

                </button>
                </div>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
                        <NavBarItem to="/register-hotel" label="New Hotel" role={[admin]}/>
                        <NavBarItem to="/register-room" label="New Room" role={[admin]}/>
                        <NavBarItem to="/hotel-list" label="Hotel List" role={[anonym, user, admin]}/>
                        <NavBarItem to="/rooms" label="Room List" role={[anonym, user, admin]}/>
                        <NavBarItem to="/search" label="Search" role={[anonym, user, admin]}/>
                    </ul>
                    <ul className="navbar-nav">
                        <NavBarItem to="/my-reservations" label="My Reservations" role={[user]}/>
                        <NavBarItem to="/login" label="Login" role={[anonym]}/>
                        <NavBarItem to="/register-user" label="Registration" role={[anonym]}/>
                        <NavBarDropDownItem role={[user, admin]}/>

                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/common/NavBar.jsx